import * as React from "react";
import { Image, IImageProps } from "@fluentui/react/lib/components/Image";
import CpbxPhoneInteractionCallRetrieve from "../CpbxPhoneInteractions/CpbxPhoneInteractionCallRetrieve";
import { LocalCacheHelper } from "../../helpers/LocalCacheHelper";
import { TooltipHost, ITooltipHostStyles, ITooltipProps } from "@fluentui/react/lib/components/Tooltip";
import { ICpbxPhoneInteractionProps } from "../CpbxPhoneInteractions/ICpbxPhoneInteractionProps";

class Verhinderung extends React.Component {
    private hostStyles: Partial<ITooltipHostStyles>;

    handleDoLogoutCbpx = (): void => {
        LocalCacheHelper.RemoveLocalCacheKeysForCbpxAll();
        window.location.reload();
    }

    private imageProps: Partial<IImageProps> = {
        src: "/assets/logo-corner-big.svg"
    }

    private imagePropsMobile: Partial<IImageProps> = {
        src: "/assets/logo-corner-small.svg"
    }

    private imagePropLogout: Partial<IImageProps> = {
        src: "/assets/Hero-Icons/Icon-Logout.svg"
    }
    /*eslint-disable */
    constructor(props) {
        super(props);
    }
    /*eslint-ensable */
    private tooltipProps: ITooltipProps = {
        onRenderContent: () => (
            <div className="cpbxStartSiteContInnerInfoToolTip">
                <h1>Quick-Info: Bitte nicht stören</h1>
                <p>Wenn Sie nicht durch Anrufe gestört werden möchten, können Sie eingehende Anrufe trotz angemeldeter Endgeräte abweisen.</p>
            </div>
        )
    };

    state = {
        tooltipId: "tooltip"
    };

    componentDidMount() {
        console.log("start componentDidMount");
        document.body.style.setProperty('--background-color', 'black');
    }

    componentWillUnmount() {
        console.log("start componentWillUnmount");
    }

    render() {

        const contextPropsCpbxPhoneInteraction: ICpbxPhoneInteractionProps = {
            hideDelayInSec: 5,
            showActionAsDisabledInSec: 2
        };

        let tmpAnrufHeranholen;
        console.log("window.location.hostname='" + window.location.hostname + "'");
        if (window.location.hostname === "telekomicpbx-app-dev.azurewebsites.net" || window.location.hostname === "localhost") {
            console.log("yes show additional function 'anruf heranholen'");
            let tmp = (
                <div className="ms-Grid-row">
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Temporäre Darstellung von "Anruf heranholen" für diese Umgebung</span>
                    <div className="ms-Grid-row cpbxStartSiteContRow">
                        <div className="ms-Grid-col ms-sm12 ms-lg12 ms-xl3 ms-xxl2 cpbxStartSiteContOuter card">
                            <CpbxPhoneInteractionCallRetrieve {...contextPropsCpbxPhoneInteraction} />
                        </div>
                    </div>
                </div>
            );
            tmpAnrufHeranholen = tmp;
        } else {
            console.log("now, do not show additional function 'anruf heranholen'");
        }


        return (
            <div>
                <div className="cpbxContOuter ms-Grid" >
                    <div className="ms-Grid-row" /* style={{ width: '100%' }} */>
                        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl4 ms-xxl6 ms-xlPush8 ms-xxlPush6 cpbxContInner cpbxContInnerLogo">
                            <div className="cpbxBgLogoCont">
                                <Image className="cpbxBgLogo" {...this.imageProps} alt="TelekomLogo" />
                            </div>
                            <div className="cpbxBgLogoCont"><Image className="cpbxBgLogoMobile" {...this.imagePropsMobile} alt="TelekomLogo" /></div>
                        </div>
                        <div className="ms-Grid-col ms-md12 ms-lg12 ms-xl8 ms-xxl6 ms-xlPull4 ms-xxlPull6 cpbxContInner">
                            <div className="cpbxLogingsiteHeader">
                                <h1>Wichtige Hinweis:</h1>
                            </div>
                            <div className="cpbxLogingsiteTitle">
                                <h2>Diese App steht nicht mehr zur Verfügung. Selbstverständlich können Sie Ihre Cloud PBX weiterhin nutzen.</h2>
                            </div>
                            <div className="cpbxText">
                                <p>
                                    Alle Funktionen von Cloud PBX stehen auch ohne App zur Verfügung.<br />Besuchen Sie für weitere Informationen unser{" "}
                                    <a
                                        className="cpbxDialogMailto"
                                        href="https://cpbx-hilfe.deutschland-lan.de/de/direkthilfe/arbeitsplatz-funktionen-und-dienste/funktionscodes"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        Hilfeportal
                                    </a>.{" "}<br />
                                    Kontaktieren Sie uns gerne unter der Rufnummer{" "}
                                    <a
                                        className="cpbxDialogMailto"
                                        href="tel:08003306708"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        0800 330 6708
                                    </a>.{" "}<br /><br />
                                    Um die App aus Teams zu entfernen, klicken Sie erst links auf &#9632;&#9632;&#9632; und öffnen dann mit der rechten Maustaste das Kontext-Menü der Cloud PBX App und wählen den Punkt Deinstallieren aus.
                                </p>

                            </div>
                        </div>
                        {/*<div className="ms-Grid-col ms-md12 ms-lg12 ms-xl8 ms-xxl6 ms-xlPull4 ms-xxlPull6 cpbxContInner cpbxContInnerWelcome">
                            <div className="cpbxHeader"><h1>Herzlich willkommen</h1></div>
                            <div className="cpbxTitle cpbxStartSiteTitle">
                                <h2>{LocalCacheHelper.getCurrentUserName()}</h2>
                                <VersionSoftwareLastUpdated />
                            </div>
                            <div className="cpbxStartSiteLogoutDiv">
                                <PrimaryButton text="Logout" allowDisabledFocus className="cpbxStartSiteLogout" style={{ borderRadius: "8px" }} onClick={this.handleDoLogoutCbpx} />
                            </div>
                        </div>*/}
                    </div>
                    {/*<div className="ms-Grid-row cpbxStartSiteContRow" >
                        <div className="ms-Grid-col ms-sm12 ms-lg12 ms-xl12 ms-xxl4 ms-xxlPush8 cpbxStartSiteContOuter ">
                            <div className="cpbxStartSiteContInnerQuickCont">
                                <div className="cpbxStartSiteContInnerQuickDiv">
                                    <h1 className="cpbxStartSiteContInnerQuickTitle">Schnelleinstellungen</h1>
                                </div>
                                <div className="cpbxStartSiteContInnerQuickNS">
                                    <div className="cpbxStartSiteContInnerNSToggle">
                                        {/* <h2>Eingehende Gespräche</h2> */}
                    {/*<CpbxPhoneSettingsDoNotDisturb />*/}
                    {/* <Toggle label="" defaultChecked /> */}
                    {/*</div>*/}
                    {/*<div className="cpbxStartSiteContInnerNSTitle">
                                        <span className="cpbxStartSiteContInnerNSTitleSpan">Bitte nicht stören</span>
                                        <TooltipHost
                                            className="cpbxStartSiteContInnerInfoTooTipHost"
                                            // content="<h1>Test</h1>Mitglieder einer Pickup-Gruppe können eingehende Anrufe untereinander übernehmen. <br />Klingelt zum Beispiel das Telefon an einem unbesetzten Arbeitsplatz, kann der Anruf von einer anderen Person übernommen und beantwortet werden. Es wird immer der zuletzt eingegangene Anruf in der Pickup-Gruppe übernommen.Möchten Sie eine neue Pickup-Gruppe erstellen oder eine bestehende ändern, wenden Sie sich bitte an Ihren zuständigen Administrator."
                                            id={this.state.tooltipId}
                                            styles={this.hostStyles}
                                            tooltipProps={this.tooltipProps}
                                        >
                                            <span aria-describedby={this.state.tooltipId} className="cpbxStartSiteContInnerNSInfoDivBtn"> </span>
                                        </TooltipHost>
                                    </div>
                                </div>
                                <div className="cpbxStartSiteContInnerQuickENU">
                                    <div className="cpbxStartSiteContInnerNSToggle">
                                        {/* <h2>Ausgehende Gespräche</h2> */}
                    {/*<CpbxPhoneSettingsCallingLineIDDeliveryBlocking />*/}
                    {/* <Toggle label="" defaultChecked /> */}
                    {/*</div>
                                    <div className="cpbxStartSiteContInnerENTitle">Eigene Rufnummer unterdrücken</div>
                                </div>
                            </div>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg12 ms-xl3 ms-xxl2 ms-xxlPull4 cpbxStartSiteContOuter card">
                            <CpbxPhoneInteractionCallLastNumberRedial {...contextPropsCpbxPhoneInteraction} />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg12 ms-xl3 ms-xxl2 ms-xxlPull4 cpbxStartSiteContOuter card">
                            <CpbxPhoneInteractionCallPickupFromPickupGroup {...contextPropsCpbxPhoneInteraction} />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg12 ms-xl3 ms-xxl2 ms-xxlPull4 cpbxStartSiteContOuter card">
                            <CpbxPhoneInteractionDirectedCallPickup {...contextPropsCpbxPhoneInteraction} />
                        </div>

                    </div>*/}

                </div>

                {/* SPECIAL for Andreas - US 895 */}
                {/*{tmpAnrufHeranholen}*/}

                {/*<div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-md12 ms-lg12 ms-xl12 ms-xxl12 cpbxContInner cpbxFooter">
                        <div>
                            <AppVersionInfo />
                        </div>
                        <div className="cpbxFeedbackLink"><AppFeedback /></div>
                    </div>
                </div>*/}
                {/*<DecommissionDialog />*/}
            </div>
        );
    }
}
export default Verhinderung;
